class NotificationSound {
  constructor() {
    // Create audio context for better browser support
    this.audioContext = null;
    this.initAudioContext();
  }

  async initAudioContext() {
    try {
      if (typeof AudioContext !== 'undefined') {
        this.audioContext = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        this.audioContext = new webkitAudioContext();
      }
    } catch (error) {
      console.warn('Audio context not supported:', error);
    }
  }

  // Generate notification sound using Web Audio API
  playNotificationSound() {
    if (!this.audioContext) {
      // Fallback to simple beep
      this.playFallbackSound();
      return;
    }

    try {
      const oscillator = this.audioContext.createOscillator();
      const gainNode = this.audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(this.audioContext.destination);

      // Create a pleasant notification sound (two tones)
      oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime);
      oscillator.frequency.setValueAtTime(600, this.audioContext.currentTime + 0.1);
      
      gainNode.gain.setValueAtTime(0, this.audioContext.currentTime);
      gainNode.gain.linearRampToValueAtTime(0.3, this.audioContext.currentTime + 0.01);
      gainNode.gain.linearRampToValueAtTime(0.3, this.audioContext.currentTime + 0.1);
      gainNode.gain.linearRampToValueAtTime(0, this.audioContext.currentTime + 0.3);

      oscillator.start(this.audioContext.currentTime);
      oscillator.stop(this.audioContext.currentTime + 0.3);
    } catch (error) {
      console.warn('Could not play notification sound:', error);
      this.playFallbackSound();
    }
  }

  // Fallback for browsers that don't support Web Audio API
  playFallbackSound() {
    try {
      // Try to use HTML5 audio with data URI
      const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmMcBjiRz+PGciMFKnvH7N2QQAkNZ+za9qhWEwr6bqTf+2acCgC9'); 
      audio.volume = 0.3;
      audio.play().catch(() => {
        // Final fallback - system beep
        console.log('🔔 Notification sound (system)');
      });
    } catch (error) {
      console.log('🔔 Notification sound (fallback)');
    }
  }

  // Play sound for new event creation
  playEventCreatedSound() {
    this.playNotificationSound();
  }

  // Play sound for service notification
  playServiceNotificationSound() {
    this.playNotificationSound();
  }
}

// Create singleton instance
const notificationSound = new NotificationSound();

export default notificationSound;